export default __webpack_public_path__ + "static/media/CSV.0dae974c.png";